//Core
//Material UI
import { AppLayout } from "@app/AppLayout";
import { EnumTheme, useAuthProvider } from "@components/AuthProvider";
import DateFnsUtils, { } from "@date-io/date-fns";
import { CssBaseline, IconButton, Theme, ThemeProvider } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { CaixaImpressao } from "@mod/Caixa/CaixaImpressao";
import FaturaRecibo from "@mod/Fatura/FaturaRecibo";
import { Login } from "@mod/Login";
import { defaultTheme, pinkTheme, purpleTheme } from "@themes/AppThemes";
import { loadCSS } from 'fg-loadcss';
import { SnackbarProvider } from "notistack";
import React from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import ptBR from 'date-fns/locale/pt-BR';
import { DespesaRecibo } from "@mod/Despesa/DespesaRecibo";
import { PagamentoComissaoRecibo } from "@mod/Vendedor/Ficha/Comissoes/PagamentoComissaoRecibo";
import { ProtocoloMovimentacao } from "@mod/Vendedor/Ficha/Movimentacoes/ProtocoloMovimentacao";

function App (props : any) {
    const notistackRef  = React.createRef<SnackbarProvider>();
    const authProvider = useAuthProvider();
    
    const getTheme = React.useCallback((themeName?: EnumTheme) => {
        switch (themeName) {
            case EnumTheme.Default:
                return defaultTheme;

            case EnumTheme.Pink:
                return pinkTheme;

            case EnumTheme.Purple:
                return purpleTheme;
                
            default:
                return defaultTheme;
        }
    }, []);
    
    const [currentTheme, setCurrentTheme] = React.useState<Theme>(() => {
        return getTheme(authProvider?.state?.themeName);
    });

    React.useEffect(() => {
        const node = loadCSS('https://use.fontawesome.com/releases/v5.12.0/css/all.css');
    
        return () => {
          node.parentNode!.removeChild(node);
        };
    }, []);

    React.useEffect(() => {
        setCurrentTheme(getTheme(authProvider?.state?.themeName))
    }, [authProvider?.state?.themeName, getTheme]);

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
            <ThemeProvider theme={currentTheme}>
                <SnackbarProvider 
                    maxSnack={3}
                    ref={notistackRef}
                    action={(key) => (
                        <IconButton color="inherit" onClick={() => {
                            notistackRef?.current?.closeSnackbar(key)
                        }}>
                            <CloseIcon />
                        </IconButton>
                    )}                    
                >
                    <Router>
                        <Switch>
                            <Route path="/Login">
                                <Login />
                            </Route>
                            
                            <Route path="/FaturaRecibo">
                                <FaturaRecibo />
                            </Route>
                            
                            <Route path="/ImprimirCaixa/:caixaId/:periodoDe/:periodoAte/">
                                <CaixaImpressao />
                            </Route>

                            <Route path="/ImprimirCaixa/:periodoDe/:periodoAte/">
                                <CaixaImpressao />
                            </Route>
                            
                            <Route path="/DespesaRecibo/:id">
                                <DespesaRecibo />
                            </Route>

                            <Route path="/PagamentoComissaoRecibo/:id">
                                <PagamentoComissaoRecibo />
                            </Route>

                            <Route path="/ProtocoloMovimentacao/:id">
                                <ProtocoloMovimentacao />
                            </Route>

                            <Route path="/">
                                <CssBaseline />
                                <AppLayout />
                            </Route>
                        </Switch>
                    </Router>
                </SnackbarProvider>
            </ThemeProvider>
        </MuiPickersUtilsProvider>
    )
}

export default App;
